import { defineCapability } from './internal';
import { args } from '../common/args';
import { CallIconStatus } from '../config/calling/constants/CallIconStatus';
export const UPDATE_CALL_ICON_STATUS_CAP = defineCapability({
  name: 'UPDATE_CALL_ICON_STATUS_CAP',
  args: {
    status: args.optional(args.oneOf(Object.values(CallIconStatus))),
    shouldShowActiveCallState: args.optional(args.bool()),
    shouldShowEndCallState: args.optional(args.bool())
  }
});